module.exports = __webpack_public_path__ + "static/media/mz.4fce86a8.svg";